import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Header from './Header/Header';
import './Platform.css';
import MenuPopup from './MenuPopup/MenuPopup';
import { useContext, useEffect, useRef, useState } from 'react';
import Promocodes from './Promocodes/Promocodes';
import ActionPopup from './ActionPopup/ActionPopup';
import { CATALOG_MAIN_LINK, ACCOUNT_MAIN_LINK, CONSTRUCTOR_MAIN_LINK, ORDERS_MAIN_LINK, PROMOCODES_MAIN_LINK, SETTINGS_MAIN_LINK, STATISTICS_MAIN_LINK, HOME_MAIN_LINK, PLATFORM_MAIN_LINK, CONTROLLERS_MAIN_LINK, SUBSCRIPTIONS_MAIN_LINK, SUBSCRIPTIONS_PLATFROM_LINK, SUBSCRIPTIONS_PROMO_SIMPLE_LINK, SUBSCRIPTIONS_PROMO_SIMPLE_WIX_LINK, SUBSCRIPTIONS_PROMO_SIMPLE_MARKETPLACE_LINK, PLATFORM_ORDERS_LINKS, PLATFORM_CATALOG_LINKS, PLATFORM_PROMOCODES_LINKS, PLATFORM_SETTINGS_LINKS, PLATFORM_CONSTRUCTOR_LINKS, ORDERS_ITEM_LINK, ORDERS_ITEM_V2_LINK, ORDERS_ITEM_DEFAULT_LINK, MAIN_PAGE_EDITOR_MAIN_LINK, PLATFORM_MAIN_PAGE_EDITOR_LINKS, ADVERTISING_CAMPAIGNS_MAIN_LINK } from '../../assets/utils/constants';
import Orders from './Orders/Orders';
import Settings from './Settings/Settings';
import Statistics from './Statistics/Statistics';
import Account from './Account/Account';
import Constructor from './Constructor/Constructor';
import Catalog from './Catalog/Catalog';
import HomePage from './HomePage/HomePage';
import MainPageEditor from './MainPageEditor/MainPageEditor';
import { ActionPopupContext } from '../../assets/contexts/actionPopupContext';
import { PlatformLinksContext } from '../../assets/contexts/platformLinksContext';
import Controllers from './Controllers/Controllers';
import Subscription from './Subscription/Subscription';
import NotFoundErrorPage from '../NotFoundErrorPage/NotFoundErrorPage';
import SimpleSubscription from './CustomSubscription/Sellavi/SimpleSubscription/SimpleSubscription';
import SimpleSubscriptionWix from './CustomSubscription/WIX/SimpleSubscription/SimpleSubscription';
import SimpleSubscriptionMarketplace from './CustomSubscription/Marketplace/SimpleSubscription/SimpleSubscription';
import BlockPopup from '../BlockPopup/BlockPopup';
import { UserContext } from '../../assets/contexts/userContext';
import { hasPermission, parsePermissions } from '../../assets/utils/utils';
import AdvertisingCampaigns from './AdvertisingCampaigns/AdvertisingCampaigns';

function Platform() {
    const { user } = useContext(UserContext)
    const navigate = useNavigate();
    const scanStateRef = useRef({
        buffer: '',
        lastTime: 0,
        timer: null,
    });
    const [popups, setPopups] = useState({
        menu: false,
        action: false,
        account: false,
        block: user?.default_shop?.subscriptions?.main?.renewal?.is_blocked,
    })

    useEffect(() => {
        setPopups(prevValue => ({
            ...prevValue,
            block: user?.default_shop?.subscriptions?.main?.renewal?.is_blocked,
        }))
    }, [user?.default_shop])
    function handlePopupOpen({ name }) {
        setPopups(prevValue => ({
            ...prevValue,
            [name]: true,
        }))
    }

    const [actions, setActions] = useState(null)

    function handleActionPopupOpen({ name, actions }) {
        console.log({ name, actions })
        handlePopupOpen({ name })
        setActions(actions)
    }

    function handlePopupClose({ name }) {
        setPopups(prevValue => ({
            ...prevValue,
            [name]: false,
        }))
    }

    const location = useLocation()

    const { links, default_link } = useContext(PlatformLinksContext)

    useEffect(() => {
        if (!user) return undefined;

        const ruToEnMap = {
            'й': 'q', 'ц': 'w', 'у': 'e', 'к': 'r', 'е': 't', 'н': 'y', 'г': 'u', 'ш': 'i', 'щ': 'o', 'з': 'p', 'х': '[', 'ъ': ']',
            'ф': 'a', 'ы': 's', 'в': 'd', 'а': 'f', 'п': 'g', 'р': 'h', 'о': 'j', 'л': 'k', 'д': 'l', 'ж': ';', 'э': '\'',
            'я': 'z', 'ч': 'x', 'с': 'c', 'м': 'v', 'и': 'b', 'т': 'n', 'ь': 'm', 'б': ',', 'ю': '.',
        };

        const transformLayout = (value) => value.split('').map((ch) => {
            const lower = ch.toLowerCase();
            const mapped = ruToEnMap[lower];
            if (!mapped) return ch;
            return ch === lower ? mapped : mapped.toUpperCase();
        }).join('');

        const isEditableTarget = (target) => {
            if (!target) return false;
            const tag = target.tagName;
            return target.isContentEditable ||
                tag === 'INPUT' ||
                tag === 'TEXTAREA' ||
                tag === 'SELECT';
        };

        const resetScanner = () => {
            const state = scanStateRef.current;
            state.buffer = "";
            state.lastTime = 0;
            if (state.timer) {
                clearTimeout(state.timer);
                state.timer = null;
            }
        };

        const sanitizeInput = (value) => {
            if (!value) return "";
            return value.replace(/[^A-Za-z0-9:/._-]/g, "");
        };

        const goToOrder = (value) => {
            if (!value) return;

            const transformed = transformLayout(value);
            const trimmed = sanitizeInput(transformed.trim());
           
            const urlMatch = trimmed.match(/orders\/(item-v2|item)\/([A-Za-z0-9]+)/i);
            let orderId = urlMatch ? urlMatch[2] : null;

            if (!orderId && /^[a-f0-9]{24}$/i.test(trimmed)) {
                orderId = trimmed;
            }

            if (!orderId) {
                const hexCandidate = trimmed.match(/([a-f0-9]{24})/i);
                if (hexCandidate) {
                    orderId = hexCandidate[1];
                }
            }

            if (!orderId) return;

            navigate(`${PLATFORM_MAIN_LINK}/${ORDERS_MAIN_LINK}/${ORDERS_ITEM_DEFAULT_LINK}/${orderId}`);
        };

        const finalizeScan = () => {
            const state = scanStateRef.current;
            if (state.buffer) {
                goToOrder(state.buffer);
            }
            resetScanner();
        };

        const handleKeyDown = (e) => {
            if (isEditableTarget(e.target)) return;
            if (e.ctrlKey || e.metaKey || e.altKey) return;

            const now = Date.now();
            const state = scanStateRef.current;

            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                finalizeScan();
                return;
            }

            if (e.key.length !== 1) return;

            const isNewSequence = !state.buffer || (now - state.lastTime > 100);
            state.buffer = isNewSequence ? e.key : state.buffer + e.key;
            state.lastTime = now;

            e.preventDefault();
            e.stopPropagation();

            if (state.timer) clearTimeout(state.timer);
            state.timer = setTimeout(finalizeScan, 120);
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            resetScanner();
        };
    }, [navigate, user]);

    return (
        <div className='platform'>
            <ActionPopupContext.Provider value={{
                handleActionPopupOpen: handleActionPopupOpen,
            }}>
                <Header
                    handlePopupOpen={handlePopupOpen}
                    isMenuOpen={popups.menu}
                    isAccountOpen={popups.account}
                />

                <div className={`platform__content ${location.pathname === `${PLATFORM_MAIN_LINK}/${HOME_MAIN_LINK}` ? 'platform__content_home' : ''}`}>
                    <Routes>
                        <Route index element={
                            <Navigate replace to={links ? default_link : PLATFORM_MAIN_LINK} />
                        }>
                        </Route>
                        <Route path={`${HOME_MAIN_LINK}/*`} element={
                            <HomePage />
                        }>
                        </Route>
                        <Route path={`${STATISTICS_MAIN_LINK}/*`} element={
                            <Statistics />
                        }>
                        </Route>
                        <Route path={`${PROMOCODES_MAIN_LINK}/*`} element={
                            hasPermission(parsePermissions(user), PLATFORM_PROMOCODES_LINKS.requiredPermissions) ?
                                <Promocodes />
                                :
                                <Navigate replace to={links ? default_link : PLATFORM_MAIN_LINK} />
                        }>
                        </Route>
                        <Route path={`${ADVERTISING_CAMPAIGNS_MAIN_LINK}/*`} element={
                            <AdvertisingCampaigns />
                        }>
                        </Route>
                        <Route path={`${ORDERS_MAIN_LINK}/*`} element={
                            hasPermission(parsePermissions(user), PLATFORM_ORDERS_LINKS.requiredPermissions) ?
                                <Orders />
                                :
                                <Navigate replace to={links ? default_link : PLATFORM_MAIN_LINK} />
                        }>
                        </Route>
                        <Route path={`${SETTINGS_MAIN_LINK}/*`} element={
                            hasPermission(parsePermissions(user), PLATFORM_SETTINGS_LINKS.requiredPermissions) ?
                                <Settings />
                                :
                                <Navigate replace to={links ? default_link : PLATFORM_MAIN_LINK} />
                        }>
                        </Route>
                        <Route path={`${ACCOUNT_MAIN_LINK}/*`} element={
                            <Account />
                        }>
                        </Route>
                        <Route path={`${CONSTRUCTOR_MAIN_LINK}/*`} element={
                            hasPermission(parsePermissions(user), PLATFORM_CONSTRUCTOR_LINKS.requiredPermissions) ?
                                <Constructor />
                                :
                                <Navigate replace to={links ? default_link : PLATFORM_MAIN_LINK} />
                        }>
                        </Route>
                        <Route path={`${MAIN_PAGE_EDITOR_MAIN_LINK}/*`} element={
                            hasPermission(parsePermissions(user), PLATFORM_MAIN_PAGE_EDITOR_LINKS.requiredPermissions) ?
                                <MainPageEditor />
                                :
                                <Navigate replace to={links ? default_link : PLATFORM_MAIN_LINK} />
                        }>
                        </Route>
                        <Route path={`${CATALOG_MAIN_LINK}/*`} element={
                            hasPermission(parsePermissions(user), PLATFORM_CATALOG_LINKS.requiredPermissions) ?
                                <Catalog />
                                :
                                <Navigate replace to={links ? default_link : PLATFORM_MAIN_LINK} />
                        }>
                        </Route>
                        <Route path={`${CONTROLLERS_MAIN_LINK}/*`} element={
                            <Controllers />
                        }>
                        </Route>
                        <Route path={`${SUBSCRIPTIONS_MAIN_LINK}/${SUBSCRIPTIONS_PLATFROM_LINK}`} element={
                            <Subscription />
                        }></Route>
                        <Route path={`${SUBSCRIPTIONS_MAIN_LINK}/${SUBSCRIPTIONS_PROMO_SIMPLE_LINK}`} element={
                            <SimpleSubscription />
                        }></Route>
                        <Route path={`${SUBSCRIPTIONS_MAIN_LINK}/${SUBSCRIPTIONS_PROMO_SIMPLE_WIX_LINK}`} element={
                            <SimpleSubscriptionWix />
                        }></Route>
                        <Route path={`${SUBSCRIPTIONS_MAIN_LINK}/${SUBSCRIPTIONS_PROMO_SIMPLE_MARKETPLACE_LINK}`} element={
                            <SimpleSubscriptionMarketplace />
                        }></Route>

                        <Route path={`/*`} element={
                            <NotFoundErrorPage />
                        }></Route>
                    </Routes>
                </div>
                <MenuPopup
                    isOpen={popups.menu}
                    handleClose={handlePopupClose}
                />
                <ActionPopup
                    isOpen={popups.action}
                    handleClose={handlePopupClose}
                    actions={actions}
                />
                <BlockPopup
                    isOpen={popups.block}
                    handleClose={handlePopupClose}
                    popupName={'block'}
                />
            </ActionPopupContext.Provider>
        </div>
    );
}

export default Platform
